import { FacebookAdSet } from "common/clients/facebook/FacebookAdSet/FacebookAdSet";
import { FacebookActionTypes } from "./FacebookActionTypes";

export const adSetsReceived = (adSets: FacebookAdSet[]) =>
  ({
    type: FacebookActionTypes.FACEBOOK_AD_SETS_RECEIVED,
    adSets,
  } as const);
